import React, { Component } from 'react';
import homeMenu from "../images/home.png"
import { Link } from "react-router-dom";
import $ from "jquery"


export default class Menu extends Component {
  componentDidMount() {
    $(".menu-toggle").click(function () {
      $(".menu-wrapper").toggleClass("menu-wrapper-active");
    });
    $(".menu-wrapper").click(function () {
      $(this).addClass("menu-wrapper-active");
    });
  }
  render() {

    return (

      <div class="menu-wrapper">
        {window.sessionStorage.getItem('authority') === "STATE" &&
          <div>
            <div class="menu-list menu-list-active">
              <Link to="/state/dashboard">
                <img src={homeMenu}></img> Home
              </Link>
            </div>
            <div class="menu-list menu-list-active">
              <Link to="/stateFund">
                <img src={homeMenu}></img> Fund Allotment
              </Link>
            </div>
            <div class="menu-list menu-list-active">
              <Link to="/proceeding">
                <img src={homeMenu}></img> Proceeding
              </Link>
            </div>
            <div class="menu-list menu-list-active">
              <Link to="/changePassword">
                <img src={homeMenu}></img> Change Password
              </Link>
            </div>
            <div class="menu-list menu-list-active">
              <Link to="/insuranceClaimList">
                <img src={homeMenu}></img>Claims
              </Link>
            </div>
            <div class="menu-list menu-list-active">
              <Link to="/stateLevel/retaggingList">
                <img src={homeMenu}></img>Re-tagging
              </Link>
            </div>
            <div class="menu-list menu-list-active">
              <Link to="/stateLevel/ownerShipChange">
                <img src={homeMenu}></img>Ownership Change
              </Link>
            </div>
            <div class="menu-list menu-list-active">
              <Link to="/stateLevel/statePolicyList">
                <img src={homeMenu}></img>Policy List
              </Link>
            </div>
            <div class="menu-list menu-list-active">
              <Link to="/stateLevel/sateApplicationList">
                <img src={homeMenu}></img>Application List
              </Link>
            </div>
            <div class="menu-list menu-list-active">
              <Link to="/reports"> 
                <img src={homeMenu}></img>Reports
              </Link>
            </div>
            <div class="menu-list menu-list-active">
              <Link   to={{ pathname: "/newUser", state: { userID: window.sessionStorage.getItem("userId"), fromPage: "pofile" } }}> 
                <img src={homeMenu}></img>Profile
              </Link>
            </div>

          </div>
        }

        {window.sessionStorage.getItem('authority') === "DOCTOR" &&
          <div>
            <div class="menu-list menu-list-active">
              <Link to="/doctorDashboard">
                <img src={homeMenu}></img> Home
          </Link>
            </div>
            <Link to="/doctorFund" class="menu-list">
              <img src={homeMenu}></img> Fund
        </Link>
            <Link to="/ApplicationList" class="menu-list">
              <img src={homeMenu}></img> Applications
        </Link>
            <Link to="/policyApplication" class="menu-list">
              <img src={homeMenu}></img> Policies
        </Link>
            <Link to="/AnimalList" class="menu-list">
              <img src={homeMenu}></img> Retagging
        </Link>
            <Link to="/changeOwner" class="menu-list">
              <img src={homeMenu}></img> Change Owner
        </Link>
            <Link to="/insuranceClaimList" class="menu-list">
              <img src={homeMenu}></img> Claims
        </Link>
            {/* <div class="menu-list">
              <img src={homeMenu}></img> Complaints
        </div>
            <div class="menu-list">
              <img src={homeMenu}></img> Contact
        </div> */}
            <Link  to={{ pathname: "/newUser", state: { userID: window.sessionStorage.getItem("userId"), fromPage: "pofile" } }} class="menu-list">
              <img src={homeMenu}></img> Profile
        </Link>
            <Link to="/changePassword" class="menu-list">
              <img src={homeMenu}></img> Change Password
        </Link>
            <div class="menu-list menu-list-active">
              <Link to="/reports">
                <img src={homeMenu}></img>Reports
              </Link>
            </div>
          </div>

        }

        {window.sessionStorage.getItem('authority') === "TALUK" &&
        <div>
          <div class="menu-list menu-list-active">
            <Link to="/taluk/dashboard">
              <img src={homeMenu}></img>Home
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/taluk/talukFundList">
              <img src={homeMenu}></img>Fund Allotment
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/taluk/talukApplicationList">
              <img src={homeMenu}></img>Application List
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/taluk/talukRetagList">
              <img src={homeMenu}></img>Retagging List
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/taluk/talukOwnerShip">
              <img src={homeMenu}></img>Owner Change
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/taluk/talukPolicyList">
              <img src={homeMenu}></img>Policy List
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/insuranceClaimList">
              <img src={homeMenu}></img>Claims List
            </Link>
          </div>
          <div class="menu-list ">
            <Link to={{ pathname: "/newUser", state: { userID: window.sessionStorage.getItem("userId"), fromPage: "pofile" } }}>
              <img src={homeMenu}></img>Profile
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/reports">
              <img src={homeMenu}></img>Reports
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/changePassword">
              <img src={homeMenu}></img> Change Password
            </Link>
          </div>
         
          </div>
        }
         {window.sessionStorage.getItem('authority') === "DISTRICT" &&
         <div>
          <div class="menu-list ">
            <Link to="/district/dashboard">
              <img src={homeMenu}></img>Home
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/district/fund">
              <img src={homeMenu}></img>Fund
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/district/districtApplicationList">
              <img src={homeMenu}></img>Application List
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/district/districtRetagList">
              <img src={homeMenu}></img>Retagging List
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/district/districtOwnerShip">
              <img src={homeMenu}></img>Owner Change
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/district/districtPolicyList">
              <img src={homeMenu}></img>Policy List
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/insuranceClaimList">
              <img src={homeMenu}></img>Claims List
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/reports">
              <img src={homeMenu}></img>Reports
            </Link>
          </div>
          <div class="menu-list ">
            <Link to={{ pathname: "/newUser", state: { userID: window.sessionStorage.getItem("userId"), fromPage: "pofile" } }}>
              <img src={homeMenu}></img>Profile 
            </Link>
          </div>
          <div class="menu-list ">
            <Link to="/changePassword">
              <img src={homeMenu}></img>Change Password
            </Link>
          </div>
          
          </div>
        }
        {window.sessionStorage.getItem('authority') === "INSURANCE_COMPANY" &&
        <div>
          <div class="menu-list menu-list-active">
            <Link to="/insurance/dashboard">
              <img src={homeMenu}></img>Home
            </Link>
          </div>
          <div class="menu-list ">
          <Link to="/policyListing">
            <img src={homeMenu}></img>Proceedings List
          </Link>
        </div>
        <div class="menu-list ">
        <Link to="/InsuranceClaimList">
          <img src={homeMenu}></img>Claims
        </Link>
      </div>
      <div class="menu-list ">
      <Link to="/insurance/retaggingList">
        <img src={homeMenu}></img>Retagged List
      </Link>
    </div>
    <div class="menu-list ">
      <Link to="/insurance/ownerChangedList">
        <img src={homeMenu}></img>Owner Change 
      </Link>
    </div>
    </div>
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/layout/doctorLeftmenu.jsx